import { Component } from '@angular/core';

@Component({
  selector: 'app-cards4-examples-23',
  templateUrl: './cards4-examples-23.component.html'
})
export class Cards4Examples23Component {}
